"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var getNormalizedDay = function (date, firstWeekDay) {
    if (firstWeekDay === void 0) { firstWeekDay = 1; }
    var day = date.getDay();
    var adjusted = (day - firstWeekDay) % constants_1.DAYS_IN_WEEK;
    var result = adjusted < 0 ? constants_1.DAYS_IN_WEEK + adjusted : adjusted;
    // Math.abs to resolve -0 value after % normalization
    return Math.abs(result);
};
exports.default = getNormalizedDay;
